module.exports = __webpack_public_path__ + "img/cs.3dc47253.jpeg";